import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import {getMobileAppStoreType} from '../utils/BrowserUtils';
import settings from '../../config/settings';
import urlJoin from 'url-join';
import {getImageUrl} from '../utils/ApiUtils';
import {ImagePropType} from '../utils/ApiPropTypes';

export default class VuCardAppLaunch extends React.Component {
  constructor() {
    super();
    this.state = {
      defaultLocation: null,
    };
  }

  componentWillMount() {
    const storeType = getMobileAppStoreType();

    if (storeType) {
      const defaultLocation = _.find(this.props.appDestination.locations, {store: storeType});
      if (defaultLocation) {
        this.setState({defaultLocation});
      }
    }
  }

  render() {
    const {destination, appDestination} = this.props;
    return (
      <div className="vuCardAppLaunch">
        <div className="vuCardAppLaunch__header">
          <img className="vuCardAppLaunch__header__logo"
               alt={appDestination.name}
               src={getImageUrl(appDestination.providerLogo)}/>
        </div>
        <div className="vuCardAppLaunch__buttons">
          <div className="row">
            <div className="columns small-6">
              <a className="vuCardAppLaunch__buttons__launch"
                 href={destination.url}
                 onClick={this.props.onLaunchClick.bind(this)}>
                <img src={urlJoin(settings.widget.appStoreLogoBaseUrl, 'launch_app.svg')}
                     alt="Launch App"/>
              </a>
            </div>
            {
              this.renderAppDownloads()
            }
          </div>
        </div>
        {
          this.renderPreviewScreen()
        }
      </div>
    );
  }

  renderAppDownloads() {
    const {defaultLocation} = this.state;

    if (defaultLocation) {
      return this.renderAppDownloadButton(defaultLocation);
    }

    return _.map(this.props.appDestination.locations, (loc, i) => this.renderAppDownloadButton(loc, i));
  }

  renderAppDownloadButton(location, i) {
    return (
      <div className={cx('columns', 'small-6', {end: i === this.props.appDestination.locations.length - 1})}
           key={location.store}>
        <a className="vuCardAppLaunch__buttons__download"
           href={location.appDownloadUrl}
           onClick={this.props.onDownloadClick.bind(this, location.appDownloadUrl)}>
          <img className="vuCardAppLaunch__buttons__download__logo"
               src={urlJoin(settings.widget.appStoreLogoBaseUrl, location.store + '.svg')}
               alt={`Download at ${location.store}`}/>
        </a>
      </div>
    );
  }

  renderPreviewScreen() {
    let previewImageUrl;
    const {defaultLocation} = this.state;

    if (defaultLocation) {
      previewImageUrl = getImageUrl(defaultLocation.appScreenImage);
    } else {
      previewImageUrl = getImageUrl(_.find(this.props.appDestination.locations, l => !!l.appScreenImage));
    }

    if (previewImageUrl) {
      return (
        <div className="vuCardAppLaunch__preview">
          <img className="vuCardAppLaunch__preview__image"
               src={previewImageUrl}
               alt="App Preview"/>
        </div>
      );
    }
  }
}

VuCardAppLaunch.propTypes = {
  network: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  destination: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  appDestination: PropTypes.shape({
    name: PropTypes.string,
    providerLogo: ImagePropType.isRequired,
    useApp: PropTypes.bool.isRequired,
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        store: PropTypes.string.isRequired,
        appScreenImage: ImagePropType,
        appDownloadUrl: PropTypes.string
      }).isRequired
    ).isRequired
  }),
  onCancel: PropTypes.func.isRequired,
  onLaunchClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired
};

VuCardAppLaunch.defaultProps = {
  onCancel: () => {},
  onLaunchClick: () => {},
  onDownloadClick: () => {}
};
